import { Component, inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AlbumsService } from '../../services/albums.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationComponent } from '../../components/pagination/pagination.component';
import { Album } from '../../models/album.model';

@Component({
  selector: 'app-album',
  imports: [DatePipe, PaginationComponent],
  templateUrl: './album.component.html',
  styles: `
    .cursor-zoom {
      cursor: zoom-in;
    }
  `
})
export class AlbumComponent implements OnInit {
  album?: Album;
  params = {
    album_name: '',
    page: 1,
    limit: 12
  };
  total = 0;

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private albumsService = inject(AlbumsService);

  ngOnInit() {
    this.params.album_name = this.route.snapshot.paramMap.get('name')!;
    this.getAlbum();
  }

  getAlbum() {
    this.album = undefined;

    this.albumsService.get(this.params).subscribe({
      next: (res) => {
        this.album = res.records;
        this.total = res.total_record;
      },
      error: (error) => {
        console.error('Error fetching album:', error);
        this.router.navigateByUrl('/galerias');
      }
    });
  }
}
